module.exports = __webpack_public_path__ + "static/media/base.a7d3d950.png";